import { Checkbox, LoadingSpinner } from "pepsico-ds";
import { getDateWithFormat } from "../../../utils/commons";

const CodeGroupsTable = ({
  codeGroupsData,
  selectedCodeGroupsList,
  loading,
  onSelectCodeGroup,
  programTimezone,
  checkboxRenderKey = "",
}) => {
  return (
    <div className="codegroups-table p-0">
      {loading ? (
        <LoadingSpinner
          size={{
            height: "30px",
            width: "30px",
          }}
          style={{ margin: "auto" }}
        />
      ) : (
        <table>
          <thead>
            <tr>
              <th className="column-checkbox"></th>
              <th className="column-brands">CODE GROUP NAME</th>
              <th className="column-keywords">STATUS</th>
              <th className="column-keywords"># OF CODES</th>
              <th className="column-keywords">USED CODES</th>
              <th className="column-keywords">ACTIVE DATES</th>
              <th className="column-keywords">TYPE</th>
            </tr>
          </thead>
          <tbody>
            {codeGroupsData?.length ? (
              codeGroupsData?.map((codeGroup) => (
                <tr key={codeGroup.codeGroupId}>
                  <td className="td-checkbox">
                    <Checkbox
                      key={`${codeGroup.codeGroupId}-${checkboxRenderKey}`}
                      id={`checkbox-${codeGroup.codeGroupId}`}
                      onUpdate={() => onSelectCodeGroup(codeGroup)}
                      checked={selectedCodeGroupsList?.some(
                        (row) => row.codeGroupId === codeGroup.codeGroupId
                      )}
                    />
                  </td>
                  <td className="td-brands">
                    {codeGroup.basicSetup?.codeGroupName}
                  </td>
                  <td className="td-brands">
                    <div className="common-status-wrapper">
                      <div
                        className={`common-status ${codeGroup.lifecycleStatus?.toLowerCase().replace(" ", "_")}`}
                      >
                        <span>{codeGroup.lifecycleStatus}</span>
                      </div>
                    </div>
                  </td>
                  <td className="td-keywords">{codeGroup.codesGeneratedCount}</td>
                  <td className="td-keywords">{codeGroup.codesUsedCount}</td>
                  {codeGroup.basicSetup?.codeActiveStartDate &&
                    codeGroup.basicSetup?.codeActiveEndDate &&
                    programTimezone && (
                      <td className="td-keywords">
                        {getDateWithFormat(
                          codeGroup.basicSetup?.codeActiveStartDate,
                          programTimezone
                        )}{" "}
                        -{" "}
                        {getDateWithFormat(
                          codeGroup.basicSetup?.codeActiveEndDate,
                          programTimezone
                        )}
                      </td>
                    )}
                  <td className="td-keywords">
                    {codeGroup.category === "SUPPORT" ? "Support" : "Default"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="no-data">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CodeGroupsTable;
